import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../../../actions/utilAction';
import { create } from 'domain';

export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const GET_PATIENT_RECORD_ABC_DATA_LIST_API = `${API_URL}/api/CollectData/GetPatientRecordABCData`;
export const POST_PATIENT_RECORD_ABC_DATA_LIST_API = `${API_URL}/api/CollectData/SavePatientRecordABCData`;
export const GET_PATIENT_RECORD_FREQUENCY_DATA_LIST_API = `${API_URL}/api/CollectData/GetPatientRecordFrequencyData`;
export const POST_PATIENT_RECORD_FREQUENCY_DATA_LIST_API =  `${API_URL}/api/CollectData/SavePatientRecordFrequencyData`
export const GET_PATIENT_RECORD_DURATION_DATA_LIST_API = `${API_URL}/api/CollectData/GetPatientRecordDurationData`;

export const GET_PATIENT_TODAYS_RECORD_ABC_DATA_LIST_API = `${API_URL}/api/CollectData/GetTodaysPatientRecordABCData`;
export const GET_PATIENT_TODAYS_FREQUENCY_DATA_LIST_API = `${API_URL}/api/CollectData/GetTodaysPatientFrequencyData`;
export const DELETE_PATIENT_TODAYS_RECORD_ABC_DATA_API = `${API_URL}/api/CollectData/DeletePatientRecordABCData`;
export const DELETE_PATIENT_TODAYS_FREQUENCY_DATA_LIST_API = `${API_URL}/api/CollectData/DeletePatientRecordFrequencyData`;
export const UPDATE_BEHAVIOR_COLLECT_DATA_API = `${API_URL}/api/CollectData/UpdateCollectedBehaviorData`;

export const POST_PATIENT_RECORD_DURATION_API =  `${API_URL}/api/CollectData/SavePatientRecordDurationData`;
export const GET_PATIENT_TODAYS_DURATION_DATA_LIST_API = `${API_URL}/api/CollectData/GetTodaysPatientDurationData`;
export const DELETE_PATIENT_TODAYS_DURATION_DATA_LIST_API = `${API_URL}/api/CollectData/DeletePatientRecordDurationData`;

export const GET_PATIENT_RECORD_RATE_API = `${API_URL}/api/CollectData/GetPatientRecordRateData`;
export const POST_PATIENT_RECORD_RATE_API = `${API_URL}/api/CollectData/SavePatientRecordRateData`;
export const GET_PATIENT_TODAYS_RATE_DATA_LIST_API = `${API_URL}/api/CollectData/GetTodaysPatientRateData`;
export const DELETE_PATIENT_TODAYS_RATE_DATA_LIST_API = `${API_URL}/api/CollectData/DeletePatientRecordRateData`;

export const GET_PATIENT_RECORD_INTERVAL_API = `${API_URL}/api/CollectData/GetPatientRecordPartialIntervalData`;
export const GET_PATIENT_RECORD_INTERVAL_CUSTOM_TIME_API = `${API_URL}/api/PatientMasterGeneralSettings/GetPatientGeneralSettingsByPatientId`;
export const POST_PATIENT_RECORD_INTERVAL_API = `${API_URL}/api/CollectData/SavePatientRecordPartialIntervalData`;
export const GET_PATIENT_TODAYS_INTERVAL_DATA_LIST_API = `${API_URL}/api/CollectData/GetTodaysPatientPartialIntervalData`;
export const DELETE_PATIENT_TODAYS_INTERVAL_DATA_LIST_API = `${API_URL}/api/CollectData/DeletePatientRecordPartialIntervalData`;

export const GET_PATIENT_RECORD_MOMENTARY_DATA_LIST_API=`${API_URL}/api/CollectData/GetPatientRecordMomentaryData`;
export const POST_PATIENT_RECORD_MOMENTARY_DATA_LIST_API = `${API_URL}/api/CollectData/SavePatientRecordMomentaryData`;
export const GET_PATIENT_TODAYS_RECORD_MOMENTARY_DATA_LIST_API = `${API_URL}/api/CollectData/GetTodaysPatientMomentaryData`
export const DELETE_PATIENT_TODAYS_RECORD_MOMENTARY_DATA_API = `${API_URL}/api/CollectData/DeletePatientRecordMomentaryData`;

export const BehaviourDataActionTypes = {
    save_patientRecordABCData: createRequestActionTypes('SAVE_PATIENT_RECORD_ABC_DATA'),
    get_patientRecordABCData_List: createRequestActionTypes('GET_PATIENT_RECORD_ABC_DATA_LIST'),
    get_patientRecordFrequencyData: createRequestActionTypes('GET_PATIENT_RECORD_FREQUENCY_DATA_LIST'),
    save_patientRecordFrequencyData: createRequestActionTypes('SAVE_PATIENT_RECORD_FREQUENCY_DATA'),
    update_collectedBehaviorDataStatus: createRequestActionTypes('UPDATE_BEHAVIOR_COLLECT_DATA'), 
    
    set_isRecordDurationRenderTrue: createRequestActionTypes('SET_IS_RECORD_DURATION_RENDER_TRUE'),
    start_recordDurationTimer: createRequestActionTypes('START_RECORD_DURATION_TIMER'),
    start_secondsElapsed: createRequestActionTypes('START_SECONDS_ELAPSED'),
    
    get_patientTodaysRecordABCDataList: createRequestActionTypes('GET_PATIENT_TODAYS_RECORD_ABC_DATA_LIST'),
    delete_patientTodaysRecordABCDataList : createRequestActionTypes('DELETE_PATIENT_TODAYS_RECORD_ABC_DATA_LIST'),
    get_patientTodaysFrequencyDataList: createRequestActionTypes('GET_PATIENT_TODAYS_FREQUENCY_DATA_LIST'),
    delete_patientTodaysFrequencyDataList : createRequestActionTypes('DELETE_PATIENT_TODAYS_FREQUENCY_DATA_LIST_API'),
    
    post_patinetRecordDurationData: createRequestActionTypes('POST_PATIENT_RECORD_DURATION_DATA'),
    get_patientRecordDurationData: createRequestActionTypes('GET_PATIENT_RECORD_DURATION_DATA'),
    get_patientTodaysDurationDataList: createRequestActionTypes('GET_PATIENT_TODAYS_DURATION_DATA_LIST'),
    delete_patientTodaysDurationDataList : createRequestActionTypes('DELETE_PATIENT_TODAYS_DURATION_DATA_LIST_API'),

    get_patientRecordRateData: createRequestActionTypes('GET_PATIENT_RECORD_RATE_DATA'), 
    start_recordRateTimer: createRequestActionTypes('START_RECORD_RATE_TIMER'),
    start_secondsElapsedForRate: createRequestActionTypes('START_SECONDS_ELAPSED_FOR_RATE'),
    reset_secondsElapsedForRate: createRequestActionTypes('RESET_SECONDS_ELAPSED_FOR_RATE'),
    save_patientRecordRateData: createRequestActionTypes('SAVE_PATIENT_RECORD_RATE_DATA'),
    get_patientTodaysRateDataList: createRequestActionTypes('GET_PATIENT_TODAYS_RATE_DATA_LIST'),
    delete_patientTodaysRateDataList : createRequestActionTypes('DELETE_PATIENT_TODAYS_RATE_DATA_LIST_API'),
    set_customRateArray: createRequestActionTypes('SET_CUSTOM_RATE_ARRAY'),
    reset_customRateArray: createRequestActionTypes('RESET_CUSTOM_RATE_ARRAY'),

    get_patientRecordIntervalData: createRequestActionTypes('GET_PATIENT_RECORD_INTERVAL_DATA'),
    get_patientRecordIntervalCustomTimeData: createRequestActionTypes('GET_PATIENT_RECORD_INTERVAL_CUSTOM_TIME_DATA'),
    start_recordIntervalTimer: createRequestActionTypes('START_RECORD_INTERVAL_TIMER'),
    start_secondsElapsedForInterval: createRequestActionTypes('START_SECONDS_ELAPSED_FOR_INTERVAL'),
    reset_secondsElapsedForInterval: createRequestActionTypes('RESET_SECONDS_ELAPSED_FOR_INTERVAL'),
    save_patientRecordIntervalData: createRequestActionTypes('SAVE_PATIENT_RECORD_INTERVAL_DATA'),
    get_patientTodaysIntervalDataList: createRequestActionTypes('GET_PATIENT_TODAYS_INTERVAL_DATA_LIST'),
    delete_patientTodaysIntervalDataList : createRequestActionTypes('DELETE_PATIENT_TODAYS_INTERVAL_DATA_LIST_API'),
    set_intervalCount: createRequestActionTypes('SET_INTERVAL_COUNT'),
    reset_IntervalCount: createRequestActionTypes('RESET_INTERVAL_COUNT'),
    set_customSelectedInterval: createRequestActionTypes('RESET_CUSTOM_SELECTED_INTERVAL'),
    reset_customIntervalArray:  createRequestActionTypes('RESET_CUSTOM_INTERVAL'),
    start_secondsElapsedForIntervalObservation: createRequestActionTypes('START_SECONDS_ELAPSED_FOR_INTERVAL_OBSERVATION'),
    reset_secondsElapsedForIntervalObservation: createRequestActionTypes('RESET_SECONDS_ELAPSED_FOR_INTERVAL_OBSERVATION'),
    set_secondsElapsedForIntervalObservationCustom: createRequestActionTypes('SET_SECONDS_ELAPSED_FOR_INTERVAL_OBSERVATION_CUSTOM'),

    start_ReverseSecondsElapsedForInterval: createRequestActionTypes('REVERSE_SECONDS_ELAPSED'),
    reset_reverseSecondsElapsedForInterval: createRequestActionTypes('RESET_RVERSE_SECONDS_ELAPSED_FOR_INTERVAL'),

    get_patientRecordMomentaryData_List: createRequestActionTypes('GET_PATIENT_RECORD_MOMENTARY_DATA_LIST'),
    save_patientRecordMomentaryData: createRequestActionTypes('GET_PATIENTS_RECORD_MOMENTARY_DATA'),
    get_patientTodaysRecordMomentaryDataList: createRequestActionTypes('GET_PATIENT_TODAYS_RECORD_MOMENTARY_DATA_LIST'),
    delete_patientTodaysRecordMomentaryDataList: createRequestActionTypes('DELETE_PATIENT_TODAYS_MOMENTARY_DATA_LIST'),
    start_recordMomentaryTimer: createRequestActionTypes('START_RECORD_MOMENTARY_TIMER'),
    start_secondsElapsedForMomentary: createRequestActionTypes('START_SECONDS_ELAPSED_FOR_MOMENTARY'),
    reset_secondsElapsedForMomentary: createRequestActionTypes('RESET_SECONDS_ELAPSED_FOR_MOMENTARY'),
    set_MomentaryIntervalCount: createRequestActionTypes('SET_MOMENTARY_INTERVAL_COUNT'),
    reset_MomentaryIntervalCount: createRequestActionTypes('RESET_MOMENTARY_INTERVAL_COUNT'),
    get_patientRecordMomentaryCustomTimeData: createRequestActionTypes('GET_PATIENT_RECORD_MOMENTARY_CUSTOM_TIME_DATA'),
    set_customMomentaryArray: createRequestActionTypes('SET_CUSTOM_MOMENTARY_ARRAY'),
    reset_customMomentaryArray: createRequestActionTypes('RESET_CUSTOM_MOMENTARY_ARRAY'),
    start_secondsElapsedForMomentaryObservation: createRequestActionTypes('START_SECONDS_ELAPSED_FOR_MOMENTARY_OBSERVATION'),
    reset_secondsElapsedForMomentaryObservation: createRequestActionTypes('RESET_SECONDS_ELAPSED_FOR_MOMENTARY_OBSERVATION'),
    ////////////////
    start_secondsElapsedReset: createRequestActionTypes('START_SECONDS_ELAPSED_RESET'),
    set_beep_flag: createRequestActionTypes('SET_BEEP_FLAG')
    /////////////
};

export const MODULE = 'DCPATIENT_BEHAVIOURCOLLECTDATA';


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/constants/ApiConstants.js